const reviewAvatars = [
  'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20person%2C%20warm%20studio%20lighting%2C%20neutral%20beige%20background%2C%20friendly%20expression%2C%20clean%20minimal%20composition%2C%20corporate%20style%20photography&width=200&height=200&seq=avatar-review-01&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20person%2C%20soft%20natural%20lighting%2C%20neutral%20gray%20background%2C%20confident%20expression%2C%20clean%20minimal%20composition%2C%20modern%20portrait%20photography&width=200&height=200&seq=avatar-review-02&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20person%2C%20warm%20ambient%20lighting%2C%20cream%20background%2C%20smiling%20expression%2C%20clean%20minimal%20composition%2C%20casual%20portrait%20style&width=200&height=200&seq=avatar-review-03&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20person%2C%20dramatic%20studio%20lighting%2C%20dark%20background%2C%20serious%20expression%2C%20clean%20minimal%20composition%2C%20editorial%20portrait%20photography&width=200&height=200&seq=avatar-review-04&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20person%2C%20bright%20natural%20lighting%2C%20white%20background%2C%20approachable%20expression%2C%20clean%20minimal%20composition%2C%20modern%20headshot%20style&width=200&height=200&seq=avatar-review-05&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20person%2C%20soft%20window%20lighting%2C%20neutral%20beige%20background%2C%20thoughtful%20expression%2C%20clean%20minimal%20composition%2C%20artistic%20portrait%20style&width=200&height=200&seq=avatar-review-06&orientation=squarish',
];

const reviews = [
  {
    title: '吃瓜第一线的神站',
    body: '自从发现了黑料吃瓜在线，我再也不怕错过任何娱乐圈大瓜了。更新速度真的快，每次有大事发生，这里都是第一时间报道。已经推荐给所有吃瓜群的群友了！',
    author: '吃瓜群众小王',
    role: '资深网友',
    stars: 5,
    avatarIdx: 0,
  },
  {
    title: '每天必刷的网站',
    body: '内容质量很高，不是那种随便造谣的营销号风格。文章写得有深度，爆料有理有据，吃瓜吃得明明白白。已经养成了每天早中晚各刷一次的习惯。',
    author: '追星十年老兵',
    role: '忠实用户',
    stars: 5,
    avatarIdx: 1,
  },
  {
    title: '八卦爱好者的天堂',
    body: '分类很清晰，娱乐圈、主播圈、网红圈都有自己的专区。想看什么类型的瓜直接进对应频道就行，比在微博上大海捞针方便太多了。',
    author: '天天吃瓜的橘子',
    role: '老用户',
    stars: 5,
    avatarIdx: 2,
  },
  {
    title: '信息很及时',
    body: '好几次都是在黑料吃瓜在线看到爆料之后，微博才上的热搜。信息源确实有一手，不是那种二手加工的内容。关注了绝对不会后悔。',
    author: '夜猫子鉴定师',
    role: '活跃用户',
    stars: 4,
    avatarIdx: 3,
  },
  {
    title: '界面干净没广告',
    body: '现在找个干净清爽的资讯网站太难了，到处都是弹窗广告和软文。黑料吃瓜在线的体验真的很好，阅读起来很舒服，没有乱七八糟的打扰。',
    author: '专注吃瓜三十年',
    role: '新用户',
    stars: 5,
    avatarIdx: 4,
  },
  {
    title: '评论区比正文还精彩',
    body: '每次看完文章都喜欢去翻评论区，网友们的评论有时候比爆料本身还有意思。氛围很好，大家都在认真讨论，不像有些平台全是水军。',
    author: '评论区一级潜水员',
    role: '常驻用户',
    stars: 5,
    avatarIdx: 5,
  },
];

export default function TestimonialSection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-accent-50/50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <div className="flex items-center justify-center gap-2 mb-4">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            <span className="text-xs font-semibold text-accent-700 uppercase tracking-wider">吃瓜热评</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
            吃瓜群众都在说
            <br />
            这里吃瓜最过瘾
          </h2>
          <p className="text-sm text-secondary-500 max-w-md mx-auto">
            来自全国各地的吃瓜爱好者的真实评价
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {reviews.map((review, idx) => (
            <article
              key={idx}
              className={`bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60 ${
                idx >= 4 ? 'opacity-70' : ''
              }`}
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }, (_, i) => (
                  <i
                    key={i}
                    className={`text-sm ${i < review.stars ? 'ri-star-fill text-accent-500' : 'ri-star-fill text-secondary-300'}`}
                  ></i>
                ))}
              </div>
              <h4 className="text-sm font-bold text-foreground-950 mb-2">{review.title}</h4>
              <p className="text-xs text-secondary-600 leading-relaxed mb-4 line-clamp-4">{review.body}</p>
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={reviewAvatars[review.avatarIdx]}
                    alt={review.author}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <p className="text-xs font-semibold text-foreground-950">{review.author}</p>
                  <p className="text-xs text-secondary-500">{review.role}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}